import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IWorkbookUsageInfo } from '../../../ts/ServerApi/types/IUsageInfo';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem, ITypedItem } from '../../../ts/ServerApi/types/resourceParts';
import { IWorkbook } from '../types/IWorkbook';

export interface IGetWorkbooksParams extends IGetItemsParams {
}

export interface IGetWorkbooksResult extends IGetItemsResult {
  workbooks?: IWorkbook[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IWorkbookUsageInfo;
  favorites?: string[];
}

export class GetWorkbooksRequest extends Request<IGetWorkbooksParams, IGetWorkbooksResult> {
  constructor(params: IGetWorkbooksParams) {
    super('getWorkbooks', params);
  }
}
